import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { getEvent } from "../api";
import { useIsBoardReferee } from "../boards/board.hooks";
import { useAuthStore } from "../stores/auth.store";
import { Event } from "./event.schema";

interface EventProps {
  isLoading: boolean;
  isError: boolean;
  event?: Event;
}
export function useEvent(initEvent?: Event): EventProps {
  const router = useRouter();
  const { eventShortLink } = router.query;
  // if (!boardShortLink && shortLink) boardShortLink = shortLink;
  const options: UseQueryOptions = {
    // staleTime: FIVE_MINUTES,
  };
  if (initEvent) options.initialData = initEvent;
  const { isLoading, isError, data } = useQuery(
    ["event", eventShortLink],
    () => (eventShortLink ? getEvent(eventShortLink?.toString()) : null),
    options as any
  );
  const event = data as Event;
  return { isError, isLoading, event };
}
export function useIsEventReferee(): boolean {
  const isBoardRef = useIsBoardReferee();
  const { event } = useEvent();
  const user = useAuthStore((state) => state.user);
  if (!event || !user) return false;
  if (user?.admin) return true;
  if (isBoardRef) return true;
  return (event.referees as string[]).includes(user._id);
}
